<template>
    <div :class="[`block block-featured-slides`]" data-aos="custom-fade-in">
        <div v-if="bgContentArray" :id="swiperContainerId" class="swiper-container">

            <div class="swiper-wrapper">
                <div class="swiper-slide"
                     v-for="(item, index) in bgContentArray"
                     :key="`featured-${index}-${Math.random()}`"
                >
                    <component
                        :is="item?.projectLink?.slug ? 'router-link' : 'div'"
                        :class="['main-anchor test2', item?.projectLink?.slug ? 'yeslink' : 'nolink']"
                        :to="item?.projectLink?.slug || null"
                    >
                        <div v-if="item.panelVideo?.length" :class="[mode, 'bgimg']">
                            <video preload="auto" :class="`video-${index}`" muted :poster="item.panelImage[0].url" webkit-playsinline="true" playsinline="true">
                                <source :src="item.panelVideo[0].url" type="video/mp4">
                            </video>
                        </div>
                        <div v-else :class="[mode, 'bgimg']" :style="item.panelImage[0].bgStyle"></div>

                        <div v-if="mode === 'home' && item.projectLink" class="panel">
                            <div class="scrim"></div>
                            <div class="capper">
                                <div class="capper-padded">
                                    <div class="copy">
                                        <h3 v-if="item.projectLink?.client"
                                            v-html="formatClients(item.projectLink?.client)"></h3>
                                        <h2>
                                            <Link
                                                :href="item.projectLink.slug"
                                                :label="item.projectLink?.title"
                                                classes=""
                                            />
                                        </h2>

                                        <h4 v-if="item.projectLink?.projectCategory"
                                            v-html="formatProjectCategories(item.projectLink?.projectCategory)"></h4>

                                        <!--<div v-if="item.projectLink.slug" class="button-outer">
                                            <Link
                                                :href="item.projectLink.slug"
                                                label="View Project"
                                                classes="link-underline-leftright-whitesmall"
                                            />
                                        </div>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </component>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
import Swiper, {Navigation, Pagination} from 'swiper';
import 'swiper/swiper-bundle.min.css';
import Link from "@/components/pieces/Link.vue";

Swiper.use([Navigation, Pagination]);

export default {
    name: "FeaturedSlides",
    components: {
        Link
    },
    data() {
        return {
            document: document,
            slider: null,
            swiperContainerId: null,
            swiperContainerSel: null,
            timeoutId: null,
            isDragging: false
        }
    },
    props: {
        bgContentArray: {
            type: Array,
            required: true,
            default: null,
        },
        mode: {
            type: String,
            required: false,
            default: '',
        }
    },
    mounted() {
        this.swiperContainerId = 'fs-' + Date.now();
        this.swiperContainerSel = '#' + this.swiperContainerId;
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {
        init() {
            this.slider = new Swiper(this.swiperContainerSel, {
                init: false,
                speed: 750,
                grabCursor: true,
                centeredSlides: true,
                loop: (this.bgContentArray.length > 1),
                allowSlidePrev: (this.bgContentArray.length > 1),
                allowSlideNext: (this.bgContentArray.length > 1),
                simulateTouch: (this.bgContentArray.length > 1),

                touchRatio: 1,       // Sensitivity for dragging
                touchAngle: 45,      // Angle of dragging to detect

                slidesPerView: 1,
                preventClicks: false,
                preventClicksPropagation: false,
                touchStartPreventDefault: true,
                allowTouchMove: false,
                navigation: {
                    nextEl: this.swiperContainerSel + ' .swiper-button-next',
                    prevEl: this.swiperContainerSel + ' .swiper-button-prev'
                },
                pagination: {
                    el: this.swiperContainerSel + ' .swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
            });
            this.slider.on('slideChangeTransitionEnd', this.onSlideChange);
            this.slider.on('afterInit', this.onSlideChange);

            setTimeout(() => this.slider.init(), 100);
        },
        onSlideChange() {
            clearTimeout(this.timeoutId);

            // const currentSlide = this.slider.slides[this.slider.realIndex];
            const container = document.querySelector(this.swiperContainerSel);
            const currentSlide = container.querySelector('.swiper-slide.swiper-slide-active');
            const video = currentSlide.querySelector('video');
            if (video) {
                video.currentTime = 0;
                video.muted = true;
                video.volume = 0;
                video.play();

                video.onended = () => {
                    this.slider.slideNext();
                };
            } else {
                this.timeoutId = setTimeout(() => {
                    this.slider.slideNext();
                }, 4000);
            }
        },
        formatClients(obj) {
            let result = '';
            for (let i = 0; i < obj.length; i++) {
                result += `<span class="txt">${obj[i].title}</span>`;
            }
            return result;
        },

        formatProjectCategories(obj) {
            let result = '';
            for (let i = 0; i < obj.length; i++) {
                result += `<span class="dot"></span><span class="txt">${obj[i].title}</span>`;
            }
            return result;
        }
    },
    beforeUnmount() {
        clearTimeout(this.timeoutId);
        if (this.slider) {
            this.slider.destroy();
        }
    }
};
</script>
